import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'mainNav',
  title: 'Main Nav',
  type: 'document',
  fields: [
    defineField({
      name: 'items',
      type: 'array',
      title: 'Nav Items',
      of: [{ type: 'mainNavItem' }],
    }),
  ],
  preview: {
    prepare() {
      return {
        title: `Main Navigation`,
        subtitle: ``,
      }
    },
  },
})